import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { coalesce } from '../../../../utils/utils';

export const getPaperlessInfo = (state) => state.paperlessSetting;
/**
 * Simple selector to grab paperless settings as defined by the service
 * @param state
 * @returns {paperlessSettings | {}} setting by product type as key
 */
export const getPaperlessSettings = (state) =>
  state.paperlessSetting.paperlessByProductType;

/**
 * Simple selector to grab if the user has updated settings in the current session
 * @param state
 * @returns {updatedValue | false} setting by product type as key
 */
export const getUpdatedPaperless = (state) =>
  state.paperlessSetting.updatedPaperless;

/**
 * Simple selector to grab if the user has clicked on either the paperless checkbox or the modal disclosure
 * @param state
 * @returns {updatedValue | false} setting by product type as key
 */
export const getHasUserInteracted = (state) =>
  state.paperlessSetting.userInteraction;

/**
 * constructor for getting paperless settings by the product type in the map
 * @param productType and state
 * @returns {Selector}
 */
const getPaperlessSettingsByProductType = (productType) =>
  createSelector(getPaperlessSettings, (paperlessSettings) => {
    return (
      paperlessSettings[productType] &&
      coalesce(paperlessSettings[productType], {})
    );
  });

/**
 * flag to determine when to show the paperless disclosure in the sell flow, could eventually be leveraged for BUY
 * but currently isn't
 * @param {constructor} and {state}
 * @returns {Boolean}
 */
export const getShowPaperlessOptIn = createSelector(
  getPaperlessSettingsByProductType('MUTUAL_FUND'),
  (mutualFundPaperlessSettings) => {
    return (
      !isEmpty(mutualFundPaperlessSettings) &&
      !mutualFundPaperlessSettings.subscribedAll
    );
  }
);

/**
 * flag to determine when to show the paperless disclosure in the sell flow, could eventually be leveraged for BUY
 * but currently isn't
 * @param {constructor} and {state}
 * @returns {Boolean}
 */
export const getHasMutualFundPaperlessConfirmations = createSelector(
  getPaperlessSettingsByProductType('MUTUAL_FUND'),
  (mutualFundPaperlessSettings) => {
    return mutualFundPaperlessSettings &&
      mutualFundPaperlessSettings.confirmations
      ? Boolean(mutualFundPaperlessSettings.confirmations)
      : false;
  }
);
